import React, { createContext, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../ActiveDatabaseContext/ActiveDatabaseContext';
import floatingBottomAreaSysoptionQuery from './Queries/FloatingBottomAreaSysoptionQuery.gql';
import type {
  FloatingBottomAreaSysoptionQuery,
  FloatingBottomAreaSysoptionQueryVariables,
} from './Queries/_QueryTypes/FloatingBottomAreaSysoptionQuery';
import { useIsTouchDevice } from '../BreakpointContext/BreakpointContextUtils';

interface IFloatingBottomAreaSysoptionContext {
  floatingBottomAreaEnabled: boolean;
}

const FloatingBottomAreaSysoptionContext =
  createContext<IFloatingBottomAreaSysoptionContext>({
    floatingBottomAreaEnabled: false,
  });

export const FloatingBottomAreaSysoptionProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const isTouchDevice = useIsTouchDevice();

  const { data } = useQuery<
    FloatingBottomAreaSysoptionQuery,
    FloatingBottomAreaSysoptionQueryVariables
  >(floatingBottomAreaSysoptionQuery, {
    variables: { dbName: activeDatabase ?? '' },
    skip: activeDatabase == null || !isTouchDevice,
  });

  const optionData = data?.db?.SYSOptions_All?.[0]?.OptionData ?? '';
  const floatingBottomAreaEnabled = optionData === 'Y';

  return (
    <FloatingBottomAreaSysoptionContext.Provider
      value={{ floatingBottomAreaEnabled }}
    >
      {children}
    </FloatingBottomAreaSysoptionContext.Provider>
  );
};

export const useFloatingBottomAreaSysoption =
  (): IFloatingBottomAreaSysoptionContext =>
    useContext(FloatingBottomAreaSysoptionContext);
